import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Facility } from './facility.model';
import { FacilitiesModalComponent } from '../components/facilities-modal/facilities-modal.component';
import { FacilityModalComponent } from '../components/facility-modal/facility-modal.component';
import { FacilityTranslationModalComponent } from '../components/facility-translation-modal/facility-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class FacilityModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openFacilitiesModal(successCallback) {
    const options = {
      width: '700px', // 1000px
      minHeight: '80vh',
      maxHeight: '80vh',
      position: { top: '5vh' },
      disableClose: true,
      data: {
        title: 'FACILITIES',
      },
      confirmCallback: successCallback,
    };

    this.modalDialogService.open(options, FacilitiesModalComponent);
  }

  openFacilityModal(
    facility: Facility,
    defaultLanguage,
    additionalLanguages,
    mode,
    successCallback = null
  ) {
    const confirmCallback = (result) => {
      // Edit
      if (facility.id) {
        facility.name = result.name;
        facility.description = result.description;
        facility.type = result.type;

        return this.utilService.changeItemRowStyle(facility.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'FACILITY_DETAILS',
        obj: facility,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          mode: mode,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, FacilityModalComponent);
  }

  openFacilityTranslation(facility: Facility, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'FACILITY_DETAILS',
        obj: facility,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, FacilityTranslationModalComponent);
  }
}
